import React from 'react'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import Box from 'src/components/Box/Box'
import NotFoundBottomContent from 'src/components/NotFoundBottomContent/NotFoundBottomContent'
import NotFoundTopContent from 'src/components/NotFoundTopContent/NotFoundTopContent'
import { css } from 'styled-components'

interface NotFoundBackgroundPageContentProps {
  className?: string
}

const NotFoundBackgroundPageContent: React.FC<
  NotFoundBackgroundPageContentProps
> = (props): React.ReactElement => {
  return (
    <BackgroundPageContent
      className={props.className}
      css={css`
        align-items: center;
      `}
    >
      <Box>
        <div
          css={css`
            padding: 20px;
          `}
        >
          <NotFoundTopContent isSmall />
        </div>
        <div
          css={css`
            padding: 20px;
          `}
        >
          <NotFoundBottomContent isSummary />
        </div>
      </Box>
    </BackgroundPageContent>
  )
}

export default NotFoundBackgroundPageContent
